import React from "react";
import Loadable from "react-loadable";

import DotSpinner from "@exovera/dot-spinner";

const ChinaMapLoader = Loadable.Map({
	loader: {
		MapComponent: () => import(/* webpackChunkName: "map" */ "genericComponents/Map"),
		chinaMapObject: () => import(/* webpackChunkName: "map" */ "static/maps/jsMaps/china.js"),
		mapIndex: () => import(/* webpackChunkName: "map" */ "lib/maps/mapIndexChina.js"),
	},
	loading: DotSpinner,
	render(loaded, props) {
		const { actions } = props;
		const Map = loaded.MapComponent.default;
		const mapIndex = loaded.mapIndex.default;
		const chinaMapObject = loaded.chinaMapObject.default;

		return (
			<Map
				{...props}
				baseIcon={false} // Pass a tiny map svg/js object here, or false to disable
				baseMapObject={chinaMapObject}							
				clickableStates={[
					"CN-AH",
					"CN-BJ",
					"CN-CQ",
					"CN-FJ",
					"CN-GD",
					"CN-GS",
					"CN-GX",
					"CN-GZ",
					"CN-HA",
					"CN-HB",
					"CN-HE",
					"CN-HI",
					"CN-HK",
					"CN-HL",
					"CN-HN",
					"CN-JL",
					"CN-JS",
					"CN-JX",
					"CN-LN",
					"CN-MO",
					"CN-NM",
					"CN-NX",
					"CN-QH",
					"CN-SC",
					"CN-SD",
					"CN-SH",
					"CN-SN",
					"CN-SX",
					"CN-TJ",
					"CN-TW",
					"CN-XJ",
					"CN-XZ",
					"CN-YN",
					"CN-ZJ",
				]}
				// dmaMap={false}
				filterByMapCountry={props.filterByMapCountry}
				filtering={false}
				interactiveEmptyMap={true}
				// trigger remount between detailed and base maps (prevents awkward transition)
				key={props.mapHighlight ? "mapHighlight" : "baseMap"}
				// mapCountyHighlight={false}
				// mapCountyHighlightId={""}
				// mapCountyHighlightColor={""}
				// mapCountyHighlightTitle={""}
				// mapCountyHighlightValue={""}
				mapHighlight={false}
				// mapHighlightColor={""}
				mapHighlightDisabled={false}
				mapId="base"
				mapIndex={mapIndex}
				// mapPlaying={false} // false or string. 'playing' or 'stopped'. false is all state
				// mapPosition={false}
				maxHeight={600} // 400 for US map
				moeMode={false}
				reactSimpleMaps={null}
				states={null}
				subtractFromHeight={100} // 360 for US map
				// wideMap // true for US map

				// actions
				changeMap={actions.changeMap}
				clearMap={actions.clearMap}
				clearMapPlay={actions.clearMapPlay}
				clickMap={actions.clickMap}
				hoverMap={actions.hoverMap}
				incrementMapPosition={actions.incrementMapPosition}
				setMapPosition={actions.setMapPosition}
				stateFilterParentId={"sourceProvince"}
				toggleMapPlay={actions.toggleMapPlay}
				toggleFilterByMapCountry={actions.toggleFilterByMapCountry}
				unhoverMap={actions.unhoverMap}
			/>
		);
	},
});

export default ChinaMapLoader;
